module.exports = {"140303001":"平潭街街道","140303003":"蔡洼街道","140303004":"赛鱼街道","140303005":"沙坪街道","140303006":"贵石沟街道","140303198":"县区直属镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140303.json
// module id = 252
// module chunks = 0